// breath indicator v3
export const outerBubbleMinHeight = 20
export const outerBubbleMobileMinHeight = 30
export const outerBubbleMaxHeight = 45

export const innerBubbleMinHeight = 10
export const innerBubbleMobileMinHeight = 15
export const innerBubbleMaxHeight = 22.5
